<template>
  <Fragment>
    <template v-if="$route.name !== 'newQrCode'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <div class="card-wrap mt-20 mb-20">
        <el-tabs>
          <el-row :gutter="24">
            <el-col :span="14">
              <div class="grid-content bg-purple">
                <span>二维码信息</span>
                <el-form
                  ref="qrForm"
                  :model="qrCode"
                  :rules="rules"
                  class="add-form"
                  label-width="100px"
                  label-position="left"
                  style="margin-top: 3%"
                >
                  <div>
                    <el-form-item label="品牌：" prop="brandId">
                      <el-select
                        v-model="qrCode.brandId"
                        clearable
                        placeholder="请选择"
                        @change="getCategoryTypeOptions(qrCode.brandId)"
                      >
                        <el-option
                          v-for="item in brandTypeOptions"
                          :key="item.brandId"
                          :label="item.brandName"
                          :value="item.brandId"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="品类：" prop="brandTypeId">
                      <el-select
                        v-model="qrCode.brandTypeId"
                        clearable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in categoryTypeOptions"
                          :key="item.brandId"
                          :label="item.brandName"
                          :value="item.brandId"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item
                      label="应用分类："
                      prop="applicationCategoryId"
                    >
                      <el-select
                        v-model="qrCode.applicationCategoryId"
                        clearable
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in applicationCategoryOptions"
                          :key="item.applicationCategoryId"
                          :label="item.applicationCategoryName"
                          :value="item.applicationCategoryId"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>

                  <div class="add-form-item">
                    <el-form-item label="主题：" prop="marketingName">
                      <el-input v-model="qrCode.marketingName"></el-input>
                    </el-form-item>
                  </div>
                  <div
                    style="    margin-top: -3%;
    margin-left: 15%;"
                  >
                    <span class="validate ml-20">
                      * 最多70个字符,不能有"/""\"空格"</span
                    >
                  </div>
                  <div class="add-form-item">
                    <el-form-item label="着陆页：" prop="marketingUrl">
                      <el-input v-model="qrCode.marketingUrl"></el-input>
                    </el-form-item>
                  </div>
                  <div
                    style="    margin-top: -3%;
    margin-left: 15%;"
                  >
                    <span class="validate ml-20"> * 最多不超过200个字符</span>
                  </div>
                  <div class="add-form-item">
                    <el-form-item label="有效期：" prop="timeArray">
                      <el-date-picker
                        v-model="timeArray"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>
                  <div
                    style="    margin-top: -3%;
    margin-left: 15%;"
                  >
                    <span class="validate ml-20"> 可不选，则默认永久有效</span>
                  </div>
                </el-form>
              </div>
              <div class="grid-content bg-purple" style="margin-top: 3%">
                <span>媒体信息</span>
                <el-form
                  ref="mediaForm"
                  :model="qrCode"
                  class="add-form"
                  label-width="100px"
                  label-position="left"
                  style="margin-top: 3%"
                >
                  <div class="add-form-item">
                    <el-form-item label="媒体类型：" prop="rdodg">
                      <el-radio v-model="qrCode.rdodg" label="1"
                        >单个媒体</el-radio
                      >
                      <!--                      <el-radio v-model="qrCode.rdodg" label="2"
                        >多个媒体</el-radio
                      >-->
                    </el-form-item>
                  </div>
                  <div v-if="mediaFlag">
                    <div>
                      <el-form-item label="投放载体：">
                        <el-select
                          v-model="qrCode.mediaTypesId"
                          clearable
                          placeholder="请选择"
                          @change="getMediaSubInfo(qrCode.mediaTypesId)"
                        >
                          <el-option
                            v-for="item in mediaOptions"
                            :key="item.mediaTypesId"
                            :label="item.mediaTypesName"
                            :value="item.mediaTypesId"
                          >
                          </el-option>
                        </el-select>
                        <el-select
                          v-model="qrCode.mediaTypesSmallId"
                          clearable
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in mediaSubOptions"
                            :key="item.mediaTypesId"
                            :label="item.mediaTypesName"
                            :value="item.mediaTypesId"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="add-form-item" prop="marketingMediaName">
                      <el-form-item label="媒体名称：">
                        <el-input
                          v-model="qrCode.marketingMediaName"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="add-form-item" prop="marketingMediaChannel">
                      <el-form-item label="媒体频道：">
                        <el-input
                          v-model="qrCode.marketingMediaChannel"
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div
                      style="    margin-top: -3%;
    margin-left: 15%;"
                    >
                      <span class="validate ml-20">
                        * 不能含有"/","\",空格等</span
                      >
                    </div>
                  </div>
                  <!--                  <div v-else>
                    <div class="add-form-item">
                      <el-form-item label="下载模板：">
                        <a
                          class="text"
                          href="/api/textAndFile/downSynopsis?fileName=营销媒体数据导入模板.xls"
                          style=" padding: 0 10px;
        text-decoration: none"
                          >下载模板</a
                        >
                      </el-form-item>
                    </div>
                  </div>-->
                  <el-form-item>
                    <el-button type="primary" @click="saveMarketing"
                      >生成二维码</el-button
                    >
                    <el-button type="primary" @click="downloadQrcode"
                      >下载二维码(透明版)</el-button
                    >
                    <el-button type="primary" @click="downloadOldQrcode"
                    >下载二维码(原版)</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
            <div
              style="float:left;width: 1px;height: 700px; background: #d4d4d4;"
            ></div>
            <div><QrCodeInfo ref="qrCodeInfo" :dataInfo="dataInfo" /></div>
          </el-row>
        </el-tabs>
      </div>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import QrCodeInfo from "./webQrCodeInfo.vue";

export default {
  components: {
    Fragment,
    QrCodeInfo
  },
  watch: {
    timeArray(val) {
      let _this = this;
      _this.qrCode.startTime = val[0];
      _this.qrCode.endTime = val[1];
    }
  },
  data() {
    return {
      dataInfo: {},
      mediaFlag: true,
      activeName: "first",
      brandTypeOptions: [],
      categoryTypeOptions: [],
      applicationCategoryOptions: [],
      mediaOptions: [],
      mediaSubOptions: [],
      timeArray: [],
      qrCode: {
        marketingId: "",
        brandId: "",
        brandTypeId: "",
        applicationCategoryId: "",
        mediaTypesSmallId: "",
        marketingName: "",
        marketingUrl: "",
        startTime: "",
        endTime: "",
        rdodg: "1",
        mediaTypesId: "",
        marketingMediaName: "",
        marketingMediaChannel: ""
      },
      rules: {
        brandId: [
          {
            required: true,
            message: "请选择品牌",
            trigger: "blur"
          }
        ],
        brandTypeId: [
          {
            required: true,
            message: "请选择品类",
            trigger: "blur"
          }
        ],
        applicationCategoryId: [
          {
            required: true,
            message: "请选择应用分类",
            trigger: "blur"
          }
        ],
        marketingName: [
          {
            required: true,
            message: "请输入主题",
            trigger: "blur"
          },
          {
            max: 70,
            message: "最多输入70个字符",
            trigger: "change"
          }
        ],
        marketingUrl: [
          {
            required: true,
            message: "请输入着陆页",
            trigger: "blur"
          },
          {
            max: 200,
            message: "最多输入200个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    //获取品牌下拉
    getBrandTypeOptions() {
      let _this = this;
      let param = {
        url: "/api/dictionaryBrand/getBrandTypeList",
        params: {
          brandId: _this.qrCode.brandId
        }
      };
      _this.$store.dispatch("getBrandTypeOptions", param).then(() => {
        _this.brandTypeOptions = _this.$store.state.brandType.brandTypeOptions;
      });
    },
    getCategoryTypeOptions(value) {
      let _this = this;
      let param = {
        url: "/api/dictionaryBrand/getBrandTypeList",
        params: {
          brandId: value
        }
      };
      _this.$store.dispatch("getBrandTypeOptions", param).then(() => {
        _this.categoryTypeOptions =
          _this.$store.state.brandType.brandTypeOptions;
      });
    },
    //获取应用分类下拉
    getApplicationCategoryOptions() {
      let _this = this;
      let param = {
        url: "/api/dictionaryCategory/getApplicationCategoryList"
      };
      _this.$store.dispatch("getApplicationCategoryOptions", param).then(() => {
        _this.applicationCategoryOptions =
          _this.$store.state.dictionaries.applicationCategoryOptions;
      });
    },
    //投放体载
    getMediaInfo() {
      let _this = this;
      let param = {
        url: "/api/dictionaryMedia/getMediaTypesPage",
        params: {
          mediaTypesId: 0
        }
      };
      _this.$store.dispatch("getMediaTypeList", param).then(() => {
        _this.mediaOptions = _this.$store.state.mediaType.mediaTypeList.list;
      });
    },
    //投放载体小类信息
    getMediaSubInfo() {
      let _this = this;
      let param = {
        url: "/api/dictionaryMedia/getMediaTypesPage",
        params: {
          mediaTypesId: _this.qrCode.mediaTypesId
        }
      };
      _this.$store.dispatch("getMediaTypeList", param).then(() => {
        _this.mediaSubOptions = _this.$store.state.mediaType.mediaTypeList.list;
      });
    },
    //生成二维码
    saveMarketing() {
      let _this = this;
      if (
        _this.qrCode.mediaTypesSmallId == null ||
        _this.qrCode.mediaTypesSmallId == "" ||
        _this.qrCode.mediaTypesSmallId == undefined
      ) {
        _this.$message({
          message: "请选择投放载体!",
          type: "error"
        });
        return false;
      }
      if (
        _this.qrCode.mediaTypesId == null ||
        _this.qrCode.mediaTypesId == "" ||
        _this.qrCode.mediaTypesId == undefined
      ) {
        _this.$message({
          message: "请选择投放载体!",
          type: "error"
        });
        return false;
      }
      _this.$refs.qrForm.validate(isPass => {
        if (isPass) {
          _this.$refs.qrCodeInfo.createCode(_this.qrCode, 1);
        }
      });
    },
    //下载二维码
    downloadQrcode() {
      let _this = this;
      _this.$refs.qrCodeInfo.downloadQrcode();
    },
    downloadOldQrcode(){
      let _this = this;
      _this.$refs.qrCodeInfo.downloadOldQrcode();
    },
    getQrcodeInfo(id) {
      let _this = this;
      _this.qrCode.marketingId = id;
      let param = {
        url: "/api/marketing/getMarketingInfoById",
        params: { marketingId: id }
      };
      _this.$Api
        .get(param.url, param.params)
        .then(response => {
          if (response.status === 200) {
            let marketInfo = response.data;
            _this.qrCode.brandId = marketInfo.brandId;
            _this.getCategoryTypeOptions(marketInfo.brandId);
            _this.qrCode.brandTypeId = marketInfo.brandTypeId;
            _this.qrCode.applicationCategoryId =
              marketInfo.applicationCategoryId;
            _this.qrCode.marketingName = marketInfo.marketingName;
            _this.qrCode.marketingUrl = marketInfo.marketingUrl;
            _this.qrCode.rdodg = "1";
            _this.qrCode.mediaTypesId = marketInfo.mediaTypesId;
            _this.getMediaSubInfo(marketInfo.mediaTypesId);
            _this.qrCode.mediaTypesSmallId = marketInfo.mediaTypesSmallId;
            _this.qrCode.marketingMediaName = marketInfo.marketingMediaName;
            _this.qrCode.marketingMediaId = marketInfo.marketingMediaId;
            _this.qrCode.marketingMediaCodeStyleId =
              marketInfo.marketingMediaCodeStyleId;
            _this.qrCode.marketingMediaChannel =
              marketInfo.marketingMediaChannel;
            let startTime = new Date(marketInfo.startTime);
            let endTime = new Date(marketInfo.endTime);
            _this.timeArray = [
              new Date(
                startTime.getUTCFullYear(),
                startTime.getUTCMonth(),
                startTime.getUTCDate()
              ),
              new Date(
                endTime.getUTCFullYear(),
                endTime.getUTCMonth(),
                endTime.getUTCDate()
              )
            ];
            _this.dataInfo = {
              data: marketInfo.codeContent,
              logoSrc: marketInfo.logo,
              size: marketInfo.size,
              foreColor: marketInfo.foreColor,
              backColor: marketInfo.backColor,
              formWork: marketInfo.formWork,
              faultToleRance: marketInfo.faultToleRance
            };
          } else {
            _this.$message({
              message: response.data.msg,
              type: "error"
            });
          }
        })
        .catch(err => {});
    }
  },
  created() {
    let _this = this;
    //加载品牌下拉
    _this.getBrandTypeOptions();
    //加载应用分类
    _this.getApplicationCategoryOptions();
    //投放载体
    _this.getMediaInfo();
    //二维码回显
    let marketingId = _this.$route.query.marketingId;
    if (
      marketingId !== null &&
      marketingId !== "" &&
      marketingId !== undefined
    ) {
      _this.getQrcodeInfo(marketingId);
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
.validate
  height: 40px
  line-height: 40px
  font-size: 10px
  color: #E6A23C
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
